import { Box, Button, TextField, TextArea, Link } from '@radix-ui/themes';
import { Form } from '@radix-ui/react-form';

export default function BlogRequestAddForm({ formData, error, handleChange, handleSubmit, isAdminPage }) {
    const fieldError = (code) => (error.code === code ? error.message : '');

    return (
        <div className="redesign-form-card">
            <Form onSubmit={handleSubmit}>
                <div className="redesign-form-field">
                    <label className="redesign-form-label" htmlFor="adminEmail">博主邮箱 *</label>
                    <TextField.Root
                        name="adminEmail"
                        id="adminEmail"
                        placeholder="用于 Gravatar 头像和邮件通知"
                        value={formData.adminEmail}
                        onChange={handleChange}
                    />
                    {fieldError('blog_request_admin_email_invalid') && (
                        <span style={{ color: '#c62828', fontSize: 13 }}>{fieldError('blog_request_admin_email_invalid')}</span>
                    )}
                </div>

                <div className="redesign-form-field">
                    <label className="redesign-form-label" htmlFor="name">博客名称 *</label>
                    <TextField.Root
                        name="name"
                        id="name"
                        placeholder="您的博客名称"
                        value={formData.name}
                        onChange={handleChange}
                    />
                    {(fieldError('blog_request_name_invalid') || fieldError('blog_submitted_with_same_ip')) && (
                        <span style={{ color: '#c62828', fontSize: 13 }}>
                            {fieldError('blog_request_name_invalid') || fieldError('blog_submitted_with_same_ip')}
                        </span>
                    )}
                </div>

                <div className="redesign-form-field">
                    <label className="redesign-form-label" htmlFor="rssAddress">RSS 地址 *</label>
                    <TextField.Root
                        name="rssAddress"
                        id="rssAddress"
                        placeholder="用于抓取文章，如 https://example.com/feed.xml"
                        value={formData.rssAddress}
                        onChange={handleChange}
                    />
                    {(fieldError('blog_request_rss_address_invalid') || fieldError('blog_request_rss_address_black_list') || fieldError('blog_request_rss_address_exists')) && (
                        <span style={{ color: '#c62828', fontSize: 13 }}>
                            {fieldError('blog_request_rss_address_invalid') || fieldError('blog_request_rss_address_black_list') || fieldError('blog_request_rss_address_exists')}
                        </span>
                    )}
                </div>

                <div className="redesign-form-field">
                    <label className="redesign-form-label" htmlFor="description">博客描述 *</label>
                    <TextArea
                        name="description"
                        id="description"
                        placeholder="描述一下您的博客，建议 100 字以内"
                        value={formData.description}
                        onChange={handleChange}
                        rows={4}
                    />
                    {fieldError('blog_request_description_invalid') && (
                        <span style={{ color: '#c62828', fontSize: 13 }}>{fieldError('blog_request_description_invalid')}</span>
                    )}
                </div>

                <Button type="submit" className="redesign-btn-primary" style={{ width: '100%', marginTop: 8 }}>
                    提交申请
                </Button>

                {!isAdminPage && (
                    <Box mt="3" style={{ textAlign: 'center' }}>
                        <Link href="mailto:bokehub@qq.com?subject=提交博客时遇到了问题&body=RSS地址：%0d%0a问题描述：%0d%0a" size="2" style={{ color: 'var(--rd-text-muted)' }}>
                            提交博客遇到问题？联系站长
                        </Link>
                    </Box>
                )}
            </Form>
        </div>
    );
}
